import { AvailableServiceTimeSlots } from '../../../data/entities/booking/AvailableServiceTimeSlots';
import { BookingEventModel } from '../../../data/entities/booking/BookingEventModel';
import { useAsync } from '../../../hooks';
import BookingService from '../../../services/booking/BookingService';
import { timeStringToDate } from '../../../utils/dateUtils';
import style from "./styles/TimeSlotPicker.module.scss";

interface TimeSlotPickerProps {
  bookingEvent: BookingEventModel;
  providerId?: number | null;
  serviceId: number;
  date: Date;
  locationId: number;
  onTimeSelect: (time: string, timeSlot: AvailableServiceTimeSlots) => void;
  isTimeSlotDisabled: (timeSlot: AvailableServiceTimeSlots) => boolean;
}

const TimeSlotPicker = ({
  bookingEvent,
  providerId,
  serviceId,
  date,
  locationId,
  onTimeSelect,
  isTimeSlotDisabled,
}: TimeSlotPickerProps) => {

  const bookingService = new BookingService();
  const {value: timeSlots, loading, error } = useAsync(
    () => bookingService.getAvailableServiceTimeSlots(
      locationId,
      providerId ?? null,
      serviceId,
      date,
      date
    ), [locationId, providerId, serviceId, date]
  );

  if (!date) return <div>Please select a date.</div>;

  return (
    <div>
      {loading && <div>Loading...</div>}
      {error && <div>Error loading time slots.</div>}
      {!loading && !error && (
        <div className="d-flex flex-wrap">
          {timeSlots?.map((timeSlot: AvailableServiceTimeSlots, index) => {
            const timeSlotTime = new Date(timeSlot.serviceStart).getTime();
            const isActive = bookingEvent.startTime && timeStringToDate(bookingEvent.startTime, date).getTime() === timeSlotTime;
            const isDisabled = isTimeSlotDisabled(timeSlot);

            return (
              <span
                key={index}
                className={`${style.time} mb-3 ${isActive ? style.active : ''} ${isDisabled ? style.disabled : ''}`}
                onClick={() => !isDisabled && onTimeSelect(timeSlot.serviceStart.toString(), timeSlot)}
              >
                {new Date(timeSlot.serviceStart).toLocaleTimeString([], {
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true,
                })}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TimeSlotPicker;
